<template>
  <sui-button :content="label" icon="logout" @click="onClick" />
</template>

<script>
export default {
  computed: {
    label() {
      return this.$auth.isLogged.value
        ? this.$t("auth.logout")
        : this.$t("auth.login");
    }
  },
  methods: {
    async onClick() {
      if (this.$auth.isLogged.value) {
        await this.$auth.logout().catch(console.error);
        // this.$router.replace({ name: "Login" });
      } else {
        return (
          this.$auth
            .startLogin({ from: this.$route.query.from })
            // TODO: user notification
            .catch(console.error)
        );
      }
    }
  }
};
</script>